import AnimateIntoView, {
  AnimationType,
} from '~/components/atoms/AnimateIntoView/AnimateIntoView'
import Container from '~/components/atoms/Container/Container'
import type { CtaProps } from '~/components/atoms/Ctas/Ctas'
import Ctas from '~/components/atoms/Ctas/Ctas'
import { Col, Grid, Row } from '~/components/atoms/Grid'
import type { ImageProps } from '~/components/atoms/Image/Image'
import Image from '~/components/atoms/Image/Image'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import { ComponentTheme } from '~/components/themes'
import { useMediaQuery } from '~/services/useMediaQuery'
import bp from '~/styles/breakpoints/breakpoints'

import styles from './MagazineIndexBanner.module.css'

export interface MagazineIndexBannerProps {
  testID?: string
  pretitle?: string
  title: string
  image: ImageProps
  ctas: CtaProps[]
  titleTag?: string
}

export default function MagazineIndexBanner({
  testID,
  pretitle,
  title,
  image,
  titleTag = 'h2',
  ctas,
}: MagazineIndexBannerProps) {
  const isMobile = useMediaQuery(`(max-width: ${bp.bpMedium})`)

  return (
    <div className={styles.base} data-testid={testID}>
      <AnimateIntoView type={AnimationType.fadeIn}>
        <Container>
          <Grid>
            <Row>
              <Col variant="col-1/2--md">
                <div className={styles.content}>
                  {pretitle && (
                    <Text
                      size={TextSizes.primaryTitleMed}
                      className={styles.pretitle}
                      Tag="p"
                    >
                      {pretitle}
                    </Text>
                  )}
                  {title && (
                    <Text
                      size={TextSizes.secondaryTitleXLrg}
                      Tag={titleTag as any}
                      className={styles.title}
                      dataNoSnippet={true}
                    >
                      <div
                        dangerouslySetInnerHTML={{
                          __html: title,
                        }}
                      />
                    </Text>
                  )}

                  {!isMobile && ctas && (
                    <Ctas ctas={ctas} theme={ComponentTheme.black} />
                  )}
                </div>
              </Col>
              <Col variant="col-1/2--md">
                <div className={styles.imageContainer}>
                  <div className={styles.media}>
                    {image && image.asset && (
                      <Image
                        asset={image.asset}
                        objectFit="cover"
                        sizes="(max-width: 799px) 80vw, 50vw"
                        alt={image.alt ? image.alt : ''}
                      />
                    )}
                  </div>
                </div>
                {isMobile && ctas && (
                  <div className={styles.cta}>
                    <Ctas ctas={ctas} theme={ComponentTheme.black} />
                  </div>
                )}
              </Col>
            </Row>
          </Grid>
        </Container>
      </AnimateIntoView>
    </div>
  )
}
